export default function ListPageEmpty({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="rounded-2xl border border-gray-200/80 bg-white py-20 px-6 flex flex-col items-center text-center shadow-[0_1px_2px_rgba(0,0,0,0.04),0_2px_8px_rgba(0,0,0,0.03)]">
      {Icon && (
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-[var(--secondary-color)]/15 to-transparent rounded-full blur-2xl" />
          <div className="relative w-20 h-20 rounded-2xl bg-gradient-to-br from-gray-50 to-gray-100 border border-gray-200 flex items-center justify-center shadow-sm">
            <Icon size={36} className="text-[var(--secondary-color)]" />
          </div>
        </div>
      )}
      {title && (
        <h3 className="mt-6 text-xl font-semibold text-gray-900">{title}</h3>
      )}
      {subtitle && (
        <p className="mt-2 max-w-md text-sm text-gray-500 leading-relaxed">
          {subtitle}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
